module.exports = __webpack_public_path__ + "img/bg_loading_error.c2616ecc.png";